export default __webpack_public_path__ + "static/media/asakusa.f3cec426.jpeg";